import React, { useEffect, useState } from "react";
import Modal from 'react-responsive-modal';
import ReleaseService from "./ReleaseService";
import Drawer from 'react-modern-drawer';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SearchMaster from "./searchMaster";
import SearchContact from "./SearchContact";
import SingleDatePicker from "../../PeriodSelection/SingleDatePicker";
import { format } from 'date-fns';
import YearPicker from "components/PeriodSelection/YearPicker";
import cachingMechanisum from "../../Common/cachingMechanisum";


export default function EditRelease(releaseDetails: any) {

    const [isOpen, setIsOpen] = React.useState(false);
    const [genreList, setGenreList] = useState<any[]>([]);
    const [subGenreList, setSubGenreList] = useState<any[]>([]);
    const [labelList, setLabelList] = useState<any[]>([]);
    const [selectedGenreId, setSelectedGenreId] = useState<number | null>(null);

    const toggleDrawer = () => {
        setIsOpen(!isOpen)
    }

    //console.log(subGenreList);
    const [values, setValues] = useState({
        catLogNumber: releaseDetails.releaseDetails.code,
        title: releaseDetails.releaseDetails.name,
        barcodeNum: releaseDetails.releaseDetails.releaseBarcode,
        artist: "",
        masterRelease: "",
        formatDesc: releaseDetails.releaseDetails.releaseFormat,
        label: "",
        mainGenre: "",
        releaseDate: "",
        subGenre: "",
        pDate: "",
        cDate: "",
        cDateOwner: "",
        pDateOwner: "",
        licenseId: ""

    });

    const search = (e: any) => {
        values.masterRelease = e.masterRelease;
        values.artist = e.artist;
        setValues((oldValues) => ({ ...oldValues, ["masterRelease"]: e.masterRelease }))
        setValues((oldValues) => ({ ...oldValues, ["artist"]: e.artist }))

    }
    const set = (name: string) => {
        return (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
            const value = event.target.value;
            setValues((oldValues) => ({ ...oldValues, [name]: value }));
        };
    };


    const functionSaveRelease = (e: any) => {
        ReleaseService.SaveRelease(values).then((res) => {

        })
    }

    const getMainGenreList = () => {
        ReleaseService.GetMainGenreList().then((res) => {
            setGenreList(res);

        })
    }

    const getLabel = () => {
        ReleaseService.GetLabelList().then((res) => {
            setLabelList(res);

        })
    }


    const handleGenreSelection = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = parseInt(event.target.value, 10);
        setSelectedGenreId(selectedId);

        // Trigger the API call
        if (selectedId) {
            ReleaseService.GetSubGenreList({ id: selectedId })
                .then((response) => {
                    setSubGenreList(response);
                    setValues((oldValues) => ({ ...oldValues, subGenre: '' }));
                })
                .catch((error) => {
                });
        }
    };

    const dateSelection = (e: any) => {
        if (e !== null) {
            values.releaseDate = format((e), "yyyyMMdd");
        }
    };

    const pDateSelection = (selectedYear: string | null) => {
        if (selectedYear !== null) {
            values.pDate = selectedYear;
            values.cDate = selectedYear;
        }
    };


    const cDateSelection = (selectedYear: string | null) => {
        if (selectedYear !== null) {
            values.cDate = selectedYear;
        }
    };

    const functionGenerateBarcode = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();

        ReleaseService.GenerateBarcode(values).then((response) => {
            setValues((oldValues) => ({ ...oldValues, barcodeNum: response.barcodeNum }));
        }).catch((error) => { });
    };


    let [SystemFormats, SetSystemFormats] = useState<any>([]);

    useEffect(() => {
        SystemFormats = cachingMechanisum.getCachingStorage("SystemFormats");
        SetSystemFormats(SystemFormats)

    }, [])

    return (
        <div>
            <button className="icon-btn edit" onClick={() => { setIsOpen(true); getMainGenreList(); getLabel() }}>
                <i className="icon-edit"></i>
            </button>

            <Drawer open={isOpen} onClose={toggleDrawer} direction="right" className="react-drawer allowHscroll forceScroll" size={800}>
                <div className="box">
                    <div className="box-header">
                        <h2><i className="icon-bar-chart pt pr"></i> Project Release Details</h2>
                    </div>

                    <div className="box-content">
                        <form className="form-horizontal" name="frmnewProjectRelease" autoComplete="off">

                            <fieldset className="scheduler-border ws-12" >
                                <legend className="scheduler-border"><h2 ><i className="fa fa-sticky-note-o"></i> Release Info</h2></legend>

                                <div className="form-format ws-6 mb">
                                    <label >Release Code*</label>
                                    <div className="label-entries ws-11">
                                        <input type="text" placeholder="Release Code" name="catLogNumber" id="releaseCode"
                                            value={values.catLogNumber}
                                            onChange={set("catLogNumber")} />

                                    </div>
                                </div>

                                <div className="form-format ws-6 mb">
                                    <label >Release Title*</label>
                                    <div className="label-entries ws-11">
                                        <input type="text" placeholder="Release Title" name="title" id="releaseTitle"
                                            value={values.title}
                                            onChange={set("title")} />
                                    </div>
                                </div>


                                <div className="form-format ws-6 mtl" >
                                    <label className="control-label">Master Release*</label>
                                    <div className="label-entries ws-11">
                                        <div className="ws-10">
                                            <input type="text" placeholder="Enter Master Release" className="form-control" name="masterRelease" id="masterRelease"
                                                value={values.masterRelease} onChange={set("masterRelease")} />
                                        </div>
                                        <div className="ws-2">
                                            {/* <SearchMaster searchFor={search} /> */}
                                        </div>
                                    </div>

                                </div>


                                <div className="form-format ws-6 mtl">
                                    <label className="control-label">Artist</label>
                                    <div className="label-entries ws-11">
                                        <input type="text" className="form-control" name="artist" placeholder="Enter Artist"
                                            value={values.artist} onChange={set("artist")} />
                                        <div className="ws-2">
                                            {/* <SearchContact /> */}
                                        </div>
                                    </div>
                                </div>

                            </fieldset>

                            <fieldset className="scheduler-border ws-12">
                                <legend className="scheduler-border"><h2 ><i className="fa fa-sticky-note-o"></i> Date Info</h2></legend>

                                <div className="ws-12">

                                    <div className="form-format ws-6">
                                        <label className="control-label">Release date</label>
                                        <div className="label-entries ws-11">
                                            <SingleDatePicker onChange={dateSelection} />
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label className="control-label">P date</label>
                                        <div className="label-entries ws-11">
                                            <YearPicker onChange={(e: any) => { pDateSelection(e) }} />
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label className="control-label"> C date </label>
                                        <div className="label-entries ws-11">
                                            <YearPicker onChange={cDateSelection} />
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label className="control-label">P line</label>
                                        <div className="label-entries ws-11">
                                            <input type="text" placeholder="Enter P/C Line" name="PCLine" id="pDateOwner"
                                                value={values.pDateOwner} onChange={set("pDateOwner")} />
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label className="control-label">Claim ID/License</label>
                                        <div className="label-entries ws-11">
                                            <input type="text" placeholder="Enter Claim ID/License" name="licenseId" id="licenseId"
                                                value={values.licenseId} onChange={set("licenseId")} />
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label className="control-label">C line</label>
                                        <div className="label-entries ws-11">
                                            <input type="text" placeholder="Enter P/C Line" name="PCLine" id="cDateOwner"
                                                value={values.cDateOwner} onChange={set("cDateOwner")} />
                                        </div>
                                    </div>

                                </div>
                            </fieldset>


                            <fieldset className="scheduler-border ws-12">
                                <legend className="scheduler-border"><h2 ><i className="fa fa-sticky-note-o"></i> Additional Info</h2></legend>

                                {/* Format */}
                                <div className="form-format ws-6 mb">
                                    <label >Formats*</label>
                                    <div className="label-entries">
                                        <select value={values.formatDesc} onChange={set("formatDesc")}>
                                            <option>Choose a format</option>

                                            {SystemFormats.filter((i: { customField: any; }) => !i.customField).map((formats: any) => (

                                                <option key={formats.formatDesc} value={formats.codingStr} >
                                                    {formats.formatDesc}
                                                </option>
                                            ))}

                                        </select>

                                    </div>
                                </div>

                                {/* Main Genre */}
                                <div className="form-format ws-6 mb">
                                    <label className="control-label">Main Genre</label>
                                    <div className="label-entries">
                                        <select onChange={(e) => { set('mainGenre')(e); handleGenreSelection(e) }}>

                                            <option>Choose a Main Genre</option>

                                            {
                                                genreList.map((post) => (
                                                    <option key={post.id} value={post.id}>
                                                        {post.name}
                                                    </option>

                                                ))}
                                        </select>

                                    </div>

                                </div>


                                {/* Label */}
                                <div className="form-format ws-6 mtl">
                                    <label className="control-label">Label</label>
                                    <div className="label-entries">
                                        <select onChange={set("label")}>
                                            <option>Choose a label</option>
                                            {
                                                labelList.map(label => (
                                                    <option key={label.labelID} value={label.companyName} >
                                                        {label.companyName}
                                                    </option>))
                                            }

                                        </select>
                                    </div>
                                </div>


                                {/* sub genre */}
                                <div className="form-format ws-6 mtl">
                                    <label className="control-label">Sub Genre</label>
                                    <div className="label-entries">
                                        <select onChange={set("subGenre")}>

                                            <option>Choose a sub-genre</option>

                                            {
                                                subGenreList.map(subG => (
                                                    <option key={subG.id} value={subG.name} >
                                                        {subG.name}
                                                    </option>))
                                            }

                                        </select>
                                    </div>
                                </div>


                                {/*upc/barcode */}
                                <div className="form-format ws-6 mtl">
                                    <label >UPC/Barcode*</label>
                                    <div className="label-entries ws-12">
                                        <div className="ws-9"><input type="text" placeholder="UPC" name="UPC"
                                            value={values.barcodeNum} onChange={set("barcodeNum")} /></div>

                                        <div className="ws-3"><button className="icon-btn edit btn-xs pull-right " onClick={functionGenerateBarcode}>
                                            <i className="icon-search"></i> Generate Barcode
                                        </button></div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>

                    </div>


                    <div className="box-footer">

                        <button className="icon-btn edit btn-xs" type="submit" onClick={functionSaveRelease}>
                            <i className="icon-save"></i>
                        </button>

                        <button className="btn-turquoise btn-xs"> <i className="icon-download1"></i> Commit</button>

                        <button className=" icon-btn delete btn-xs">
                            <i className="icon-refresh"></i>
                        </button>
                    </div>

                </div>

            </Drawer>
        </div>


    )
}